import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import Promise from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/prompt.constant";

export {
    addPrompts,
    addSinglePrompt,
    updateSinglePrompt,
    getSinglePrompt,
    searchPrompts,
    searchPromptsWithSearchCriteria,
    preparePromptsList
}

const collectionName = 'prompts';
const collectionReference = collection(fireStoreDB, collectionName);

const addPrompts = (prompts) => {
    return Promise.map(prompts, async prompt => {
        await addSinglePrompt(prompt);
    });
}

const addSinglePrompt = (prompt) => {
    prompt.createdAt = new Date();
    prompt.updatedAt = prompt.createdAt;
    return addDoc(collectionReference, prompt);
}

const updateSinglePrompt = (prompt) => {
    const documentReference = doc(fireStoreDB, collectionName, prompt.id);
    prompt.updatedAt = new Date();
    return setDoc(documentReference, prompt);
}

const getSinglePrompt = (promptId) => {
    const documentReference = doc(fireStoreDB, collectionName, promptId);
    return getDoc(documentReference);
}

const searchPrompts = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const promptResult = await getDocs(searchQuery);
    return preparePromptsList(promptResult);
}

const searchPromptsWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPromptsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }
    
    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const promptResult = await getDocs(searchQuery);
    return preparePromptsList(promptResult);
}

const preparePromptsList = (promptResult) => {
    const promptsList = [];

    _.forEach(promptResult.docs, promptDoc => {
        promptsList.push({
            ...promptDoc.data(),
            id: promptDoc.id
        });
    });

    return promptsList;
}
